import { useConsent } from '@/lib/consent';
import { isMetaPixelConfigured } from './client';

/** Consent-aware Meta Pixel enablement: true only when consent allows and env config is valid. */
export const useMetaPixelEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isMetaPixelConfigured();
};
